import type { GameKind } from '@client/entity/game/common/core/domain/constant/game-kind.constant';
import type { GameScope } from '@client/entity/game/common/core/domain/constant/game-scope.constant';

export class ClientGame {
  public constructor(
    public readonly id: string,
    public readonly title: string,
    public readonly type: GameKind,
    public readonly isInSubscription: boolean,
    public readonly scope: GameScope | null,
    public readonly accessCode: string | null,
    public readonly startDate: string | null,
    public readonly endDate: string | null,
  ) {}
}
